import React, { Component } from "react";
import { Row, Col, Button, Alert } from "reactstrap";
import { Link } from "react-router-dom";
import { MdArrowBack } from "react-icons/md";
import Formsy from "formsy-react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { TextInput, MyCheckbox, MySelect } from "../Shared/Forms";
import { Spinner } from "../Shared";

import { clientActions } from "./actions/clients.actions";
import { domainActions } from "../Domains/actions/domains.actions";
import { routeConstants } from "../../_constants";

export class ClientForm extends Component {
  state = {
    canSubmit: false
  };

  componentDidMount() {
    this.getClient();
    this.getAllDomains();
  }

  componentWillUnmount() {
    this.props.resetClient();
  }

  getClient = () => {
    const { match } = this.props;
    if (match.params && match.params.id) {
      this.props.getClient(match.params.id);
    }
  };

  getAllDomains = () => {
    this.props.getAllDomains();
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.submitted) {
      this.refs.clientForm.reset();
      this.issuerCode.changeValue(null);
    }
  }

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  enableButton = () => {
    this.setState({ canSubmit: true });
  };

  createRequest = data => {
    let request = { ...data };

    if (request.domain) {
      request.primaryDomain = request.domain.code;
      delete request.domain;
    }

    return request;
  };

  handleSubmit = data => {
    let requestBody = this.createRequest(data);
    const { match } = this.props;
    const hasParams = match.params && match.params.id;
    if (hasParams) {
      requestBody = {
        id: match.params.id,
        ...requestBody
      };
    }
    this.props.addClient(requestBody);
  };

  render() {
    const { canSubmit } = this.state;
    const {
      submitting,
      match,
      viewResponse,
      viewError,
      fetched,
      fetchingDomains,
      domainResponse,
      domainError
    } = this.props;
    const client = viewResponse && fetched ? viewResponse.modelList[0] : null;
    const hasParams = match.params && match.params.id;

    const selectedValue =
      client &&
      domainResponse &&
      domainResponse.modelList.filter(
        domain => domain.code === client.primaryDomain
      );

    return (
      <div>
        <Row>
          <Col sm="6">
            <Link
              className="btn btn-outline btn-primary"
              to={routeConstants.CLIENTS.path}
            >
              <MdArrowBack /> Back to list
            </Link>
          </Col>
          <Col sm="6">
            <div className="text-right">
              <h5 className="item-count">
                {hasParams ? "Edit" : "Add"} Client
                <small>{client && hasParams ? `: ${client.code}` : null}</small>
              </h5>
            </div>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col sm="4">
            {viewError ? (
              <Alert color="danger">
                <strong>Error:</strong> {viewError.message}
              </Alert>
            ) : (
              <Formsy
                ref="clientForm"
                onValidSubmit={this.handleSubmit}
                onValid={this.enableButton}
                onInvalid={this.disableButton}
                noValidate
              >
                <TextInput
                  name="code"
                  disabled={hasParams}
                  value={client && hasParams ? client.code : null}
                  required
                  title="Client"
                />
                <TextInput
                  name="description"
                  value={client && hasParams ? client.description : null}
                  required
                  title="Client description"
                />
                <div>
                  {fetchingDomains ? (
                    <Alert color="info">
                      <Spinner message="Fetching Issuers" />
                    </Alert>
                  ) : (
                    <div>
                      <MySelect
                        name="domain"
                        value={
                          client && hasParams && selectedValue
                            ? selectedValue[0]
                            : null
                        }
                        title="Primary Domain"
                        options={domainResponse ? domainResponse.modelList : []}
                        valueKey="code"
                        disabled={submitting}
                        labelKey="code"
                        validating={submitting}
                        innerRef={c => {
                          this.issuerCode = c;
                        }}
                        isClearable={true}
                        required
                      />
                      {!domainResponse && domainError && (
                        <Alert color="danger">
                          {domainError.message}
                          <div className="text-reight">
                            <Button color="danger" onClick={this.getAllDomains}>
                              Retry
                            </Button>
                          </div>
                        </Alert>
                      )}
                    </div>
                  )}
                </div>
                <MyCheckbox
                  name="enabled"
                  title="Enable Client"
                  validating={submitting}
                  value={client && hasParams ? client.enabled : false}
                />
                <Button
                  type="submit"
                  color="primary"
                  disabled={!canSubmit || submitting}
                >
                  {submitting ? <Spinner /> : "Submit"}
                </Button>
              </Formsy>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { submitting, submitted, request, response, error } = state.addClient;
  const {
    fetching: fetchingDomains,
    fetched: fetchedDomains,
    response: domainResponse,
    error: domainError
  } = state.domains;
  const {
    fetching,
    fetched,
    request: viewRequest,
    response: viewResponse,
    error: viewError
  } = state.viewClient;

  return {
    submitting,
    submitted,
    request,
    response,
    error,
    fetching,
    fetched,
    viewRequest,
    viewResponse,
    viewError,
    fetchingDomains,
    fetchedDomains,
    domainResponse,
    domainError
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addClient: bindActionCreators(clientActions.addClient, dispatch),
    resetClient: bindActionCreators(clientActions.resetClient, dispatch),
    getClient: bindActionCreators(clientActions.getClient, dispatch),
    getAllDomains: bindActionCreators(domainActions.getAllDomains, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClientForm);
